/*feeds mixin*/

// vuex
import { mapGetters } from "vuex";

//helpers
import filterByNumber from "../../helpers/filterByNumber";

export const threads = {
  computed: {
    ...mapGetters([
      "loading",
      "feeds",
      "hasSearch",
      "mainFeeds"
    ]),
    showPagination() {
      return !Object.keys(this.mainFeeds).length || this.hasSearch;
    },
    showNotFound() {
      return !Object.keys(this.mainFeeds).length && this.hasSearch;
    },
  },
  methods: {
    getPage() {
      let data = null;

      if (!this.hasSearch) {
        data = this.mainFeeds.slice(
          (this.getStartPage() - 1) * this.pageSize, this.currentPage * this.pageSize
        );
      } else {
        data = this.mainFeeds.slice(
          0, this.mainFeeds.length
        );
      }
      console.log('jjj', data)
      this.page = []
      data.map((it, id) => this.page[id] = [it]);
      console.log('page', this.page)
    },
    isLoadAdditional(feeds) {
      return feeds.some(elem => !elem.additional);
    },
    setPage(page) {
      this.currentPage = page;
    },
    getStartPage() {
      if (this.hasSearch) {
        return 1;
      }

      return this.currentPage;
    }
  },
  watch: {
    mainFeeds(value) {
        this.getPage();
    }
  },
};
